import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from '../../Global/Layout';
import { API_CONFIG } from '../../../contexts/constants';
import { formatDateTimeDefault } from '../../../utils/dateFormatter';

const Views = ({ onLogout, userRole, menuType }) => {
	const [rule, setRule] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		fetchActiveRule();
	}, [menuType]);

	if (!['sysadmin', 'owner', 'admin', 'agent', 'customer'].includes(userRole)) {
		window.location.href = '/forbidden';
		return null;
	}

	const fetchActiveRule = async () => {
		try {
			setLoading(true);
			const response = await axios.get(`${API_CONFIG.BASE_URL}/rules/${menuType === "rules-powerball" ? "pb" : "mg"}`, {
				headers: {
					'Authorization': `Bearer ${localStorage.getItem('token')}`
				}
			});

			if (response.data.success && response.data.data) {
				const activeRule = response.data.data || null;
				setRule(activeRule);

				if (!activeRule) {
					setError('ยังไม่มีกติกาที่เปิดใช้งาน');
				}
			} else {
				setError('ไม่พบข้อมูลกติกา');
			}
		} catch (error) {
			console.error('Error fetching rules:', error);
			setError('ไม่สามารถโหลดข้อมูลได้');
		} finally {
			setLoading(false);
		}
	};

	return (
		<Layout title={menuType === "rules-powerball" ? "กติกาการเล่น Powerball" : "กติกาการเล่น Mega Millions"} onLogout={onLogout} userRole={userRole}>
			<div className="space-y-6">
				{loading ? (
					<div className="flex justify-center items-center py-20">
						<div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
					</div>
				) : error ? (
					<div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-6 text-center">
						<svg className="w-16 h-16 text-yellow-500 dark:text-yellow-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
						</svg>
						<h3 className="text-lg font-semibold text-yellow-800 dark:text-yellow-300 mb-2">
							ไม่พบข้อมูล
						</h3>
						<p className="text-yellow-700 dark:text-yellow-400">{error}</p>
					</div>
				) : rule ? (
					<div className="bg-white dark:bg-gray-800 rounded-lg shadow-md">
						{/* Header */}
						<div className="border-b border-gray-200 dark:border-gray-700 p-6">
							<h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
								{rule.title}
							</h1>
							<div className="flex items-center text-sm text-gray-500 dark:text-gray-400">
								<svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
								</svg>
								<span>อัพเดตล่าสุด: {formatDateTimeDefault(rule.updatedDate)}</span>
							</div>
						</div>

						{/* Content */}
						<div className="p-6">
							<div
								className="prose prose-slate dark:prose-invert max-w-none
									prose-headings:text-gray-900 dark:prose-headings:text-white
									prose-p:text-gray-700 dark:prose-p:text-gray-300
									prose-li:text-gray-700 dark:prose-li:text-gray-300
									prose-strong:text-gray-900 dark:prose-strong:text-white
									prose-a:text-blue-600 dark:prose-a:text-blue-400
									prose-h2:text-xl prose-h2:font-bold prose-h2:mb-4 prose-h2:mt-6
									prose-h3:text-lg prose-h3:font-semibold prose-h3:mb-3 prose-h3:mt-5
									prose-ul:list-disc prose-ul:ml-6 prose-ul:space-y-2
									prose-ol:list-decimal prose-ol:ml-6 prose-ol:space-y-2"
								dangerouslySetInnerHTML={{ __html: rule.detail }}
							/>
						</div>

						{/* Footer */}
						<div className="border-t border-gray-200 dark:border-gray-700 p-6 bg-gray-50 dark:bg-gray-900/50">
							<div className="flex items-start space-x-3">
								<svg className="w-5 h-5 text-blue-600 dark:text-blue-400 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
								</svg>
								<div className="flex-1">
									<p className="text-sm text-gray-600 dark:text-gray-400">
										หากมีข้อสงสัยเกี่ยวกับกติกาการเล่น กรุณาติดต่อฝ่ายบริการลูกค้า
									</p>
								</div>
							</div>
						</div>
					</div>
				) : (
					<div className="bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-6 text-center">
						<p className="text-gray-600 dark:text-gray-400">ไม่พบข้อมูลกติกา</p>
					</div>
				)}
			</div>
		</Layout>
	);
};

export default Views;
